export const acceptImageAndDoc =
  ".jpg, .jpeg, .png, .gif, .webp, .pdf, .doc, .docx, .zip, .rar, video/*, audio/*";
export const acceptImage = ".jpg, .jpeg, .png, .gif, .webp";
